export const SET_DEVICE = "SET_DEVICE";

export const setDevice = (payload) => {
  return {
    type: SET_DEVICE,
    payload: payload,
  };
};
